import IResponse = ZoneIQCalibration.IResponse;
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import { CalibrationGeneralValue } from '../../models/calibrations/calibration-general-value.model';

const API = environment.ZONEIQ_CALIBRATION + '/v1/calibration-general';

@Injectable({
    providedIn: 'root'
})
export class CalibrationGeneralService {
    constructor(private readonly http: HttpClient) {}

    saveChanges(calibrationGeneralData: CalibrationGeneralValue[]) {
        if (!_.get(calibrationGeneralData, 'length', 0)) {
            return;
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams().append('syncChanges', 'true');

        return this.http.post<IResponse>(API, calibrationGeneralData, { headers, params });
    }
}
